var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.362 17.179l-5.508-6.3 5.508-6.3a1.226 1.226 0 1 0-1.847-1.613L.3 10.065a1.226 1.226 0 0 0 0 1.614l6.212 7.112a1.227 1.227 0 0 0 1.85-1.612z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.09 9.645H1.226a1.226 1.226 0 0 0 0 2.452H21.09a6.458 6.458 0 1 1 0 12.915H2.861a1.226 1.226 0 0 0 0 2.452H21.09a8.91 8.91 0 1 0 0-17.82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.5b0c235814ed9a54a92dd4ebf8ee595c.svg";
export { ForwardRef as ReactComponent };